import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "~/lib/utils";

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "ekv:flex ekv:items-center ekv:gap-2 ekv:text-sm ekv:leading-none ekv:font-medium ekv:select-none ekv:group-data-[disabled=true]:pointer-events-none ekv:group-data-[disabled=true]:opacity-50 ekv:peer-disabled:cursor-not-allowed ekv:peer-disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
